import { Link, URLSearchParamsInit } from 'react-router-dom';
import { Params } from 'ahooks/lib/useAntdTable/types';
import { SorterResult } from 'antd/lib/table/interface';
import { RawAxiosRequestHeaders } from 'axios';

import { apiGet } from 'api';

import { addQueryParamsToURL, getTableQueryParams } from 'utils';

import { Links } from 'links';

import { OfferDashboardDto, OffersDashboard } from 'codegen';
import { TColumn } from 'types';

export const columns = (sortOrderInfo?: SorterResult<OfferDashboardDto>): TColumn<OfferDashboardDto>[] => [{
  width: 70,
  title: 'ID',
  dataIndex: 'order',
  sorter: true,
  sortOrderInfo,
  render: (order, { id }) => (
    <Link
      to={`${Links.Offers}/${id}`}
      state={{ redirectFrom: `${Links.Offers}${window.location.search}` }}
    >
      {order}
    </Link>
  ),
}, {
  type: TColumn.type.FetchImageByID,
  width: 80,
  title: 'Image',
  dataIndex: 'imageMetadataId',
}, {
  type: TColumn.type.Ellipsis,
  width: 300,
  title: 'Name',
  dataIndex: 'name',
}, {
  width: 120,
  dataIndex: 'displayPriorityZone',
  titleInfo: {
    title: 'Zone',
    info: 'Display Priority Zone',
  },
}, {
  width: 140,
  title: 'Bonus Points',
  dataIndex: 'miles',
  sorter: true,
  sortOrderInfo,
}, {
  type: TColumn.type.Status,
  width: 100,
  title: 'Status',
  dataIndex: 'status',
  sorter: true,
  sortOrderInfo,
}, {
  type: TColumn.type.Date,
  width: 200,
  title: 'Effective From',
  dataIndex: 'effectiveFrom',
  dateFormat: 'YYYY/MM/DD hh:mm:ss A',
  sorter: true,
  sortOrderInfo,
}, {
  type: TColumn.type.Date,
  width: 200,
  title: 'Display From',
  dataIndex: 'displayFrom',
  dateFormat: 'YYYY/MM/DD hh:mm:ss A',
  sorter: true,
  sortOrderInfo,
}, {
  type: TColumn.type.Date,
  width: 200,
  title: 'Effective To',
  dataIndex: 'effectiveTo',
  dateFormat: 'YYYY/MM/DD hh:mm:ss A',
  sorter: true,
  sortOrderInfo,
}];

export const handleOffersTableChange = (
  headers: RawAxiosRequestHeaders,
  setSearchParams: (nextInit: URLSearchParamsInit) => void,
  setSortOrderInfo: (data: SorterResult<OfferDashboardDto>) => void,
) => async (
  params: Params[0],
) => {
  const tableQueryParams = getTableQueryParams(params, 'order');

  setSearchParams(tableQueryParams);

  if (params.sorter?.field) {
    setSortOrderInfo(params.sorter);
  }

  const url = addQueryParamsToURL('/offers/all', tableQueryParams);

  const { data } = await apiGet<OffersDashboard>({ url, headers });

  return {
    list: data.offers,
    total: data.total,
  };
};
